export function WorkerBadge({ worker, small = false }) {
  const icons = {
    healthy: '😊',
    injured: '🩹',
    sick: '🤢',
    immature: '👶',
    dead: '💀'
  };

  return (
    <span
      className={`inline-flex items-center justify-center ${small ? 'text-lg' : 'text-2xl'}`}
      role="img"
      aria-label={`Worker ${worker.id}: ${worker.status}`}
    >
      {icons[worker.status]}
    </span>
  );
}
